<template>
  <div>
    <b-modal
        centered
        no-close-on-backdrop
        no-close-on-esc
        v-model="modelShow"
        no-stacking
        hide-footer
    >
      <template slot="modal-header">
        <div slot="header" class="bg-white border-0">
          <div class="row align-items-center">
            <div class="col-12">
              <h3 class="mb-0">
                ฟอร์มยืนยันผู้ใช้บริการส่งพัสดุ
                <small>( บัตรประชาชน )</small>
              </h3>
            </div>
          </div>
        </div>
      </template>
      <card shadow type="secondary" class="m--4">
        <template>
          <h6 class="heading-small text-muted mb-2">ข้อมูลบัตรประชาชนผู้ส่งพัสดุ</h6>
          <div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group label="ประเภทลูกค้า">
                  <b-form-radio-group v-model="sender.customer_type">
                    <b-form-radio value="0">บุคคลธรรมดา</b-form-radio>
                    <b-form-radio value="1">นิติบุคคล</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> ชื่อ-นามสกุล / ชื่อบริษัท
                  </label>
                  <input
                      type="text"
                      class="form-control"
                      ref="sender_name"
                      v-model="sender.name"
                      :autofocus="'autofocus'"
                      :class="{ 'is-invalid': submitAddIdCard && nameError }"
                  />

                  <div
                      v-if="submitAddIdCard &&  nameError === 1"
                      class="invalid-feedback"
                  >กรุณากรอกชื่อ-นามสกุล</div>
                  <div
                      class="error invalid-feedback"
                      v-if="submitAddIdCard &&  nameError === 2"
                  >กรุณากรอก"ชื่อ-นามสกุล" ไม่เกิน {{sender.name.length}} ตัวอักษร</div>
                </div>
              </div>
              <div class="col-lg-6" ref="Sender">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger" v-if="$THEME.optionalDOB">*</small> วันเกิด
                    <small>(วัน/เดือน/พ.ศ.)</small>
                  </label>
                  <input
                      type="text"
                      ref="sender_birthday"
                      v-model="sender.birthday"
                      placeholder="DD/MM/YYYY"
                      v-on:keyup="$emit('formatDate')"
                      class="form-control"
                  />
                  <div
                      class="error invalid-feedback"
                  >กรุณากรอก"วันเกิด"ให้ถูกต้อง</div>
                  <div
                      class="error invalid-feedback"
                  >กรุณากรอก"วันเกิด"ให้ถูกต้อง</div>
                  <small
                      v-if="errorBirthday"
                      class="text-danger"
                  >กรุณากรอก"วันเกิด"ให้ถูกต้อง</small>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> หมายเลขโทรศัพท์
                  </label>
                  <autocomplete
                      :search="searchSenderDetails"
                      @submit="onSubmitSenders"
                      @input="sender.tel = $event.target.value"
                      :value="sender.tel"
                      ref="sender_tel"
                      class="senderTel"
                      :class="{ 'is-invalid': telError && submitAddIdCard}"
                  >
                    <template v-slot:result="{ result, props }">
                      <li v-bind="props">
                        <h6 class="d-flex  align-items-center">
                          {{result.name}} <i class="fas fa-angle-double-right px-1"></i> {{result.type == 0 ?'บุคคลธรรมดา':'นิติบุคคล'}}  <i class="fas fa-angle-double-right px-1"></i>{{result.mobile}} <i class="fas fa-angle-double-right px-1"></i>{{result.postcode}} {{result.district}} {{result.city}} {{result.province}}
                        </h6 >
                      </li>
                    </template>

                  </autocomplete>
                  <div
                      v-if="telError === 1  && submitAddIdCard"
                      class="error invalid-feedback d-block"
                  >
                    <!--  请输入您的电话号码   -->
                    กรุณากรอกหมายเลขโทรศัพท์
                  </div>
                  <div v-if="telError === 4  && submitAddIdCard" class="error invalid-feedback d-block">กรุณากรอกเฉพาะตัวเลข</div>
                  <div
                      class="error invalid-feedback d-block"
                      v-if="telError === 2  && submitAddIdCard"
                  >
                    <!--  请至少输入多少位   -->
                    กรุณากรอก"หมายเลขโทรศัพท์" อย่างน้อย {{sender.tel}} หลัก
                  </div>
                  <div
                      class="invalid-feedback d-block"
                      v-if="telError === 3 && submitAddIdCard"
                  >กรุณากรอก"หมายเลขโทรศัพท์" ไม่เกิน 10 หลัก</div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> หมายเลขบัตรประชาชน/หมายเลข Passport
                  </label>

                  <input
                      type="text"
                      ref="sender_id_no"
                      v-model="sender.id_no"
                      class="form-control"
                      :class="{ 'is-invalid': submitAddIdCard && idNoError}"
                      @change="$emit('checkIdNo')"
                  />

                  <div
                      v-if="submitAddIdCard && idNoError === 1"
                      class="invalid-feedback"
                  >กรุณากรอกหมายเลขบัตรประชาชน/หมายเลข Passport</div>
                  <div
                      class="error invalid-feedback"
                      v-if="submitAddIdCard && idNoError === 2"
                  >กรุณากรอก"หมายเลขบัตรประชาชน/หมายเลข Passport" อย่างน้อย {{sender.id_no.length}} หลัก</div>
                  <div
                      class="error invalid-feedback"
                      v-if="submitAddIdCard && idNoError === 3"
                  >กรุณากรอก"หมายเลขบัตรประชาชน/หมายเลข Passport" ไม่เกิน {{sender.id_no.length}} หลัก</div>
<!--                  <small-->
<!--                      v-if="errorIdCard"-->
<!--                      class="text-danger"-->
<!--                  >กรุณากรอกหมายเลขบัตรประชนชนให้ถูกต้อง</small>-->
                  <!-- <small
                    v-if="errorPassport"
                    class="text-danger"
                  >กรุณากรอกหมายเลข Passport ให้ถูกต้อง</small>-->
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> ที่อยู่
                  </label>

                  <input
                      type="text"
                      ref="sender_address"
                      class="form-control"
                      v-model="sender.address"
                      :class="{ 'is-invalid': submitAddIdCard && addressError }"
                  />

                  <div
                      v-if="submitAddIdCard && addressError === 1"
                      class="invalid-feedback"
                  >กรุณากรอกที่อยู่</div>
                  <div
                      class="error invalid-feedback"
                      v-if="submitAddIdCard && addressError === 2"
                  >กรุณากรอก"ที่อยู่" ไม่เกิน {{sender.address.length}} ตัวอักษร</div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> ตำบล/แขวง
                  </label>
                  <AutocompletesAddress
                      ref="sender_state"
                      :queryInput="sender.state"
                      :adsTypes="'sub-district'"
                      :class="{ 'is-invalid': submitAddIdCard && districtError }"
                      @input="sender.state = $event.target.value"
                      @select:item="onSubmitAddress($event ,'sender' )">
                  </AutocompletesAddress>
                  <div
                      v-if="submitAddIdCard && districtError===1"
                      class="invalid-th-address"
                  >กรุณากรอกตำบล/แขวง</div>
                  <div
                      class="invalid-th-address"
                      v-if="submitAddIdCard && districtError===2"
                  >กรุณากรอก"ตำบล/แขวง" ไม่เกิน {{sender.state.length}} ตัวอักษร</div>
                </div>
                <!-- ตำบล/แขวง -->
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> อำเภอ/เขต
                  </label>
                  <AutocompletesAddress
                      ref="sender_district"
                      :queryInput="sender.district"
                      :adsTypes="'district'"
                      :class="{ 'is-invalid': submitAddIdCard && cityError }"
                      @input="sender.district = $event.target.value"
                      @select:item="onSubmitAddress($event ,'sender' )">
                  </AutocompletesAddress>
                  <div
                      v-if="submitAddIdCard && cityError === 1"
                      class="invalid-th-address"
                  >กรุณากรอกอำเภอ/เขต</div>
                  <div
                      class="invalid-th-address"
                      v-if="submitAddIdCard && cityError === 2"
                  >กรุณากรอก"อำเภอ/เขต" ไม่เกิน {{sender.district.length}} ตัวอักษร</div>
                </div>
                <!-- อำเภอ/เขต -->
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <div class="form-group">
                  <label floater>
                    <small class="text-danger">*</small> จังหวัด
                  </label>
                  <AutocompletesAddress
                      ref="sender_province"
                      :queryInput="sender.province"
                      :adsTypes="'province'"
                      :class="{ 'is-invalid': submitAddIdCard && provinceError }"
                      @input="sender.province = $event.target.value"
                      @select:item="onSubmitAddress($event ,'sender' )">
                  </AutocompletesAddress>
                  <div
                      v-if="submitAddIdCard && provinceError === 1"
                      class="invalid-th-address"
                  >กรุณากรอกจังหวัด</div>
                  <div
                      class="invalid-th-address"
                      v-if="submitAddIdCard && provinceError === 2"
                  >กรุณากรอก"จังหวัด" ไม่เกิน {{sender.province.length}} ตัวอักษร</div>
                </div>
                <!-- จังหวัด -->
              </div>

              <div class="col-lg-6">
                <div class="form-group addressinput-zipcode-pos">
                  <label floater>
                    <small class="text-danger">*</small> รหัสไปรษณีย์
                  </label>
                  <AutocompletesAddress
                      ref="sender_postcode"
                      :queryInput="sender.postcode"
                      :adsTypes="'postcode'"
                      :class="{ 'is-invalid': submitAddIdCard && postcodeError}"
                      @input="sender.postcode = $event.target.value"
                      @select:item="onSubmitAddress($event ,'sender' )">
                  </AutocompletesAddress>
                  <div
                      class="invalid-th-address"
                      v-if="submitAddIdCard && postcodeError === 1"
                  >กรุณากรอกรหัสไปรษณีย์</div>
                  <div
                      class="error invalid-th-address"
                      v-if="submitAddIdCard &&  postcodeError === 2"
                  >กรุณากรอก"รหัสไปรษณีย์" {{sender.postcode.length}} หลัก</div>
                  <div
                      class="error invalid-th-address"
                      v-if="submitAddIdCard &&  postcodeError === 3"
                  >กรุณากรอก"รหัสไปรษณีย์" {{sender.postcode.length}} หลัก</div>
                  <div
                      class="error invalid-th-address"
                      v-if="submitAddIdCard &&  postcodeError === 4"
                  >กรุณากรอกเฉพาะตัวเลข</div>
                </div>
                <!-- รหัสไปรษณีย์ -->
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label floater>เลขประจำตัวผู้เสียภาษี</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="sender.tax"
                  />
<!--                  <div-->
<!--                      class="error invalid-feedback"-->
<!--                      v-if="submitAddIdCard && !sender.tax.numeric"-->
<!--                  >กรุณากรอกเฉพาะตัวเลข</div>-->
                  <div
                      class="error invalid-feedback"
                  >กรุณากรอก"เลขประจำตัวผู้เสียภาษี" ไม่เกิน {{sender.tax}} ตัวอักษร</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 w-100 text-right">
            <b-button
                variant="secondary"
                class="mx-3"
                @click="closeModel()"
            >
              ยกเลิก
            </b-button>
            <b-button
                type="submit"
                class="w-25"
                variant="success"
                @click="selectSenderInfo()"
            >ยืนยัน</b-button>
          </div>
        </template>
      </card>
    </b-modal>
  </div>
</template>
<script>
import AutocompletesAddress from "@/components/Autocomplete/AddressTH/AutocompleteAddressTH.vue";
import {getAgentUserAddress} from "@/api/express";
import moment from "moment/moment";
export default {
  components:{
    AutocompletesAddress
  },
  props:{
  },
  data(){
    return {
      modelShow:false,
      sender: {
        id_no: "",
        name: "",
        birthday: "",
        tel: "",
        address: "",
        customer_type: "0",
        state: "",
        district: "",
        postcode: "",
        province: "",
        tax: "",
        identity: false,
        mem_id: 0,
        remark_label: "",
        areaCode:''
      },
      senderList:[],
      submitAddIdCard: false,
      errorBirthday:false,
      errorIdCard:false,
      telMinLengthError:false,
    }
  },
  computed:{
    // 手机号校验
    telError(){
      if (!this.sender.tel){
        return 1
      }else if(this.sender.tel && this.sender.tel.length < 9){
        return 2
      }else if(this.sender.tel && this.sender.tel.length > 10){
        return 3
      }else{
        console.log(/\D/.test(this.sender.tel))
        if (/\D/.test(this.sender.tel)){
          return 4
        }else {
          return 0
        }
      }
    },
  // 名字校验
    nameError(){
      if (!this.sender.name){
        return 1
      }else{
        if (this.sender.name.length > 50){
          console.log(this.sender.name.length)
          return 2
        }else{
          return 0
        }
      }
    },
  //   证件号码校验
    idNoError(){
      if (!this.sender.id_no){
        return 1
      }else{
        if (this.sender.id_no.length < 8){
          return 2
        }else if(this.sender.id_no.length > 13){
          return 3
        }else{
          return 0
        }
      }
    },
  //   详细地址校验
    addressError(){
      if (!this.sender.address){
        return 1
      }else if(this.sender.address && this.sender.address.length > 120){
        return 2
      }else{
        return 0
      }
    },
    // 区校验
    districtError(){
      if(!this.sender.state){
        return 1
      }else if(this.sender.state && this.sender.state.length > 120){
        return 2
      }else{
        return 0
      }
    },
    // 市校验
    cityError(){
      if(!this.sender.district){
        return 1
      }else if(this.sender.district && this.sender.district.length > 120){
        return 2
      }else{
        return 0
      }
    },
    // 省校验
    provinceError(){
      if(!this.sender.province){
        return 1
      }else if(this.sender.province && this.sender.province.length > 120){
        return 2
      }else{
        return 0
      }
    },
    // 邮编校验
    postcodeError(){
      if(!this.sender.postcode){
        return 1
      }else if(this.sender.postcode && this.sender.postcode.length < 5){
        return 2
      }else if(this.sender.postcode && this.sender.postcode.length > 5){
        return 3
      }else if(/\D/.test(this.sender.postcode)){
        return 4
      }else{
        return 0
      }
    },
  },
  methods:{
    showSelectSender(){
      this.modelShow = true
    },
    closeModel(){
      this.modelShow = false
    },
    // 获取寄件人寄件地址列表
    searchSenderDetails(value){
      let params = {
        mobile:value,
        pageIndex:1,
        pageSize:10,
      }
      const TIME = 500;
      let setTime
      return new Promise((resolve) => {
        if (value.length < 3) {
          return resolve([]);
        }
        if (isNaN(value)) {
          return resolve([]);
        }
        clearTimeout(setTime);
        setTime = setTimeout(function() {
          console.log('11111')
          getAgentUserAddress(params)
              .then((res) => {
                console.log(res.data.records)
                resolve(res.data.records)
              })
        }, TIME);
      });
    },
    // 提交寄件人信息
    onSubmitSenders(result) {
      console.log(result)
      this.sender.tel = result.mobile
      this.sender.name = result.name
      this.sender.id_no = result.userCertInfo.passportNum
      this.sender.tax = result.tax
      this.sender.customer_type = result.type
      this.sender.birthday = result.birthday!='0000-00-00 00:00:00'?moment( result.birthday ).add(543, 'Y').format("DD/MM/YYYY"):''
      this.sender.address = result.adress
      this.sender.district = result.city
      this.sender.state = result.district
      this.sender.province = result.province
      this.sender.postcode = result.postcode
      this.sender.areaCode = result.areaCode
    },
    // 获取地址列表信息
    async onSubmitAddress(ads, objKey) {
      console.log(ads, objKey)

      Object.keys(this[objKey]).forEach(key => {
        if (ads[key]) {
          this[objKey][key] = ads[key]
        } else if (key == 'state') {
          this[objKey]['state'] = ads['sub-district']
        }
        else {
          this[objKey][key] = this[objKey][key]
        }
      })

      if (objKey == 'to') {
        this.checkDestinationCourier()
        await this.callCheckProblemCategory()
      }

    },

  //   切换身份证号
    checkIdNo(value){
      console.log(value)
      this.idNoError = false
    },
  //    确认寄件人信息
    selectSenderInfo(){
      this.submitAddIdCard = true
      if (!this.postcodeError && !this.provinceError && !this.cityError && !this.districtError && !this.addressError && !this.idNoError && !this.nameError && !this.telError){
        localStorage.setItem("senderInfo", JSON.stringify(this.sender))
        this.$emit('addParcelInfo')
      }

    }
  }
}
</script>
